import React from 'react'
import {encode as base64_encode} from 'base-64';
import { PDFDownloadLink } from "@react-pdf/renderer";
import { PdfDocument } from "./CertificatePDF";

export const CertificatesScreenC = ({id, name, display, imgSpO, imgSpT, imgSpTh, imgSpF, imgIco, transTxt, coursesL }) => {
    
    const disCourse = ()=>{
        // console.log(coursesL) 
        //let couseL = coursesL.find(course => course.id === id)
        let couseL = coursesL
        // let couseL = JSON.parse(window.sessionStorage.getItem(`listCourse${id}`))
        // console.log(couseL) 
        window.localStorage.setItem('couseL', couseL.primary_color)
        let certN = "certificate"+ couseL.name +".pdf"
        return (
            <div className="content-progress">
                <div className="ct-progress">
                    <img className="img-progress" src = {(couseL.icon_button_type==='svg')?`data:image/svg+xml;base64,${base64_encode(couseL.icon_button)}`:`data:image/${couseL.icon_button_type}+xml;base64,${btoa(couseL.icon_button)}`} alt={couseL.name}/>
                </div>
                <div className="ct-progress-b">
                    <span  className="ct-progress-b-txt">{couseL.name}</span>
                    {(display === 1)?
                    <PDFDownloadLink
                    
                    document={<PdfDocument data={couseL} 
                    orientation="landscape"
                    name={name} 
                    imgSpO = {imgSpO}
                    imgSpT = {imgSpT}
                    imgSpTh = {imgSpTh}
                    imgSpF = {imgSpF}
                    imgIco = {imgIco}
                    transTxt = {transTxt}/>}
                    fileName= {certN}
                    style={{
                    marginTop:"10px",
                    textAlign: "center",
                    fontSize:"18px",
                    textDecoration: "none",
                    padding: "10px",
                    color: "#fff",
                    backgroundColor: `${couseL.primary_color}`,
                    border: "1px solid #4a4a4a",
                    borderRadius: "15px"
                    }} 
                    >
                    {({ blob, url, loading, error }) =>
                    loading ? "Loading document..." : `${transTxt.certificado.descarga}` 
                    }
                    </PDFDownloadLink>
                    : <span 
                        style={{
                        marginTop:"10px",
                        textAlign: "center",
                        fontSize:"18px",
                        textDecoration: "none",
                        padding: "10px",
                        color: "#fff",
                        backgroundColor: `${couseL.primary_color}`,
                        border: "1px solid #4a4a4a",
                        borderRadius: "15px"
                        }} >{transTxt.certificado.no_finaliza}</span>}
                </div>
                <br/>
                <br/>
            </div>
        )
    }

    return (
        <>
            {disCourse()}
        </>
    )
}
